module.exports = __webpack_public_path__ + "static/media/AMAZON_POLISH_JACEK.24b72df2.mp3";